import { FC, useContext, useMemo, useState } from 'react';

import { ContextMenu, Table, useContextMenu } from '@smartshell/ui-kit';
import { Column } from 'react-table';

import { AuthContext } from 'auth';
import { LayoutContext } from 'components/Layout';
import { LocalizationContext } from 'localization';
import { TGameAccount } from 'types';

import { IGameAccountsTableProps } from '../interfaces';
import s from './GameAccountsTable.module.scss';
import { TableHeader } from './TableHeader';
import { useColumnsTable } from './useColumnsTable';
import { useContextMenuItems } from './useContextMenuItems';

export const GameAccountsTable: FC<IGameAccountsTableProps> = ({ group }) => {
  const { t } = useContext(LocalizationContext);
  const layoutElement = useContext(LayoutContext);

  const {
    data: { permissions },
  } = useContext(AuthContext);

  const COLUMNS: Array<Column<TGameAccount>> = useMemo(
    () => useColumnsTable(t, permissions),
    [t, permissions]
  );

  const [selectedAccounts, setSelectedAccounts] = useState<Array<TGameAccount>>(
    []
  );

  const {
    contextMenuData,
    onContextMenu,
    closeContextMenu,
    cursorPosition,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
  } = useContextMenu<TGameAccount>();

  const items = useContextMenuItems(group, selectedAccounts);

  return (
    <div>
      {contextMenuData && cursorPosition && (
        <ContextMenu
          layoutElement={layoutElement}
          data={contextMenuData}
          items={items}
          closeContextMenu={closeContextMenu}
          position={cursorPosition}
        />
      )}
      <Table
        className={s.table}
        headerBlock={<TableHeader group={group} />}
        data={group.accounts}
        columns={COLUMNS}
        emptyDataPlaceholder={t('accounts.placeholder')}
        onContextMenu={onContextMenu}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        getRowClassName={() => s.row}
        onRowClick={(event, row, table) => {
          // event.button = 2 if it's right-click event
          if (event.button === 2 && row.isSelected) {
            return;
          }

          if (!event.ctrlKey) {
            table.toggleAllRowsSelected(false);
          }

          row.toggleRowSelected(!row.isSelected);

          // wait for sync code exec and update
          Promise.resolve().then(() =>
            setSelectedAccounts(
              table.selectedFlatRows.map((selectedRow) => selectedRow.original)
            )
          );
        }}
      />
    </div>
  );
};
